.title {
    color: var(--dib-brand-base);
}

.groupLabel {
    font-weight: 400;
    font-size: var(--mantine-font-size-sm);
    color: var(--dib-text-dark-blue-rgb);
    margin-bottom: var(--mantine-spacing-lg);
}

.groupStack {
    margin-top: var(--mantine-spacing-md);
}

.itemRow {
    padding-block: var(--mantine-spacing-md);
    border-bottom: 1px solid var(--dib-brand-grey-rgb-1);

    &:last-of-type {
        margin-bottom: var(--mantine-spacing-lg);
    }

    &:hover {
        background-color: var(--dib-brand-grey-rgb-0);
        cursor: pointer;
    }
}

.itemLink {
    text-decoration: none;
    color: inherit;
}

.itemName {
}
